import { isEqual } from 'lodash';

const toNullableBooleanFromArray = booleanArray => {
  if (isEqual(booleanArray, ['false'])) {
    return 'false';
  } else if (isEqual(booleanArray, ['true'])) {
    return 'true';
  } else {
    return null;
  }
};

export { toNullableBooleanFromArray };
